import React, { useState } from "react";
import { Button, CloseButton, Modal, Spinner } from "react-bootstrap";


const WaitingBox=({message})=> {

  return (
    <>
    
      <Modal
        show={true}
        size="sm"
        centered
        backdrop="static"
        keyboard={false}
      
      >
<Modal.Body style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
  <Spinner animation="border" size="sm" role="status" />
  <span style={{ marginLeft: '10px' }}>{message}</span>
</Modal.Body>
      </Modal>
    </>
  );
}

export default WaitingBox;